import CloseIcon from "@/components/icons/CloseIcon";
import { useRef } from "react";

const TamaraModal = ({ show, setShow, locale, amount }) => {
  const ref = useRef();
  const installmentDuratuion = Number(process.env.NEXT_PUBLIC_TAMARA_INSTALLMENT) || 24;

  return (
    show && (
      <div
        ref={ref}
        className="w-[90vw] min-[768px]:w-8/12 overflow-hidden h-[80vh] shadow-lg min-[768px]:h-[614px] rounded-md fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[999999] bg-white"
      >
        <CloseIcon
          onClick={() => setShow(false)}
          className="absolute cursor-pointer start-4 top-4"
        />
        <iframe
          width="100%"
          height="100%"
          src={`https://cdn.tamara.co/widget/tamara-introduction.html?lang=${locale}&price=${amount}&currency=SAR&countryCode=SA&colorType=default&showBorder=true&paymentType=installment&numberOfInstallments=${installmentDuratuion}&disableInstallment=false&disablePaylater=true&widgetType=product-widget`}
        ></iframe>
      </div>
    )
  );
};

export default TamaraModal;
